import {Directive, ElementRef, HostListener} from '@angular/core'

@Directive({
    selector: '[appDecimal]',
    standalone: false
})
export class DecimalDirective {

    private input: HTMLInputElement
    private cursorSemSelecionar: boolean = false
    private valor: string = ''
    private cursorPosition: number = 0

    constructor(el: ElementRef) {
        this.input = el.nativeElement
    }

    @HostListener('click', ['$event']) focouUsandoMouse(e: any) {
        //Se o usuario clicar uma vez retorne true, se nao, retorne false
        this.cursorSemSelecionar = this.focoNormal()
    }

    @HostListener('focus', ['$event']) focouNoInput(e: any) {
        e.preventDefault()
        //Quando o usuario entra no input, o todos os digitos serao selecionados porque o usuario entrou com um TAB
        if (!this.cursorSemSelecionar) this.input.setSelectionRange(0, this.input.value.length)
        this.cursorSemSelecionar = false
    }

    @HostListener('paste', ['$event']) validaColar(e: any) {

        e.preventDefault()
        this.valor = e.clipboardData.getData('text/plain')

        this.cursorPosition = this.input.selectionStart || 0

        //Se o texto tiver mais que 1 virgula, retorne
        if (this.valor.match(/[.,]{2,}/g)) return

        if (!this.validaDigito()) return

        this.alterarValor()

        this.input.setSelectionRange(this.input.value.length, this.input.value.length)
    }

    @HostListener('keypress', ['$event']) insereDigitos(e: any) {

        e.preventDefault()
        this.valor = e.key.toString()

        this.cursorPosition = this.input.selectionStart || 0

        if (!this.validaDigito()) return

        this.alterarValor()

        //Apos adicionar o digito eu avanco o cursor em 1 casa
        this.input.setSelectionRange(this.cursorPosition + 1, this.cursorPosition + 1)

    }

    @HostListener('blur', ['$event']) adicionaMascara(e: any) {

        this.input.value.match(/,$/g) ? this.input.value = this.input.value + '00' :
            this.input.value.match(/,\d{1}$/g) ? this.input.value = this.input.value + '0' :
                !this.input.value.match(/,/) ? this.input.value = this.input.value + ',00' :
                    ''

        //Como alem das opces anteriores essa tambem pode ser verdadeira junto com elas, entao eu faco essa checagem separado para que ela tambem seja verificada
        if (this.input.value.match(/^,/)) this.input.value = '0' + this.input.value

    }

    private focoNormal(): boolean {
        return this.input.selectionStart === this.input.selectionEnd
    }

    private alteraValorParcialmenteSelecionado(data: any, cursorPosition: any, posicaoFinalCursor: any, valor: any) {
        data.splice(cursorPosition, ((posicaoFinalCursor + 1) - cursorPosition), valor)
        this.input.value = data.join('')
    }

    private validaDigito(): boolean {
        //Se o tipo de valor nao for numerico, virgula ou ponto, retorne
        if (!this.valor.match(/,|\.|\d/g)) return false

        //Se o usuario digitar virgula ou ponto e ja tiver uma virgula, porem o usuario nao focou no input usando TAB (porque se estiver selecionado e o usuario digitar um ponto ja existindo um, nao apagaria o texto anterior), retorne
        if ((this.input.value.match(/,/) && this.valor.match(/[.,]/g)) && this.cursorSemSelecionar) return false

        //Se o valor jà tiver duas casas decimais e o usuario tentar digitar depois da virgula, retorne
        if (this.input.value.match(/,\d{2}/g) && (this.cursorPosition >= (this.input.value.length - 2))) return false

        //Se o usuario digitar um ponto, troque por virgula
        if (this.valor.match(/\./g)) this.valor = this.valor.replace('.', ',')

        return true
    }

    private alterarValor() {

        //Transformei o valor em um array para poder inserir o novo digito em qualquer lugar onde o cursor estiver
        let data = this.input.value.split('')
        data.splice(this.cursorPosition, 0, this.valor)
        
        //Se selecionar parte do valor chama a funcao que insere o valor no trecho correspondente, se o foco estiver normal, insere o valor normalmente, se entrar com TAB, vai apagar o valor anterior do input, e resertar a posicao do cursor
        !this.focoNormal() && (this.cursorPosition !== 0 || this.input.selectionEnd !== this.input.value.length) ? this.alteraValorParcialmenteSelecionado(data, this.cursorPosition, this.input.selectionEnd, this.valor) :
            this.cursorSemSelecionar ? this.input.value = data.join('') :
                (() => {
                    this.input.value = this.valor
                    this.cursorPosition = 0
                })()

        //Faco isso para caso tenha focado usando TAB nos proximos digitos ele ja trata como se estivesse entrado no input sem o TAB
        this.cursorSemSelecionar = true

    }
}